import default_pfp_2d from 'default_pfp_2d.svg';

$(() => {
  const fileInput = $('#user_profile_photo');
  const imagePreview = $('.account-edit-image-preview > img');
  const uploadImageLabel = $('.account-edit-section.image > .underline');
  const imageClear = $('.account-edit-image-preview > span');

  // Trigger click on file input
  imagePreview.click(() => {
    fileInput.trigger('click');
  });
  uploadImageLabel.click(() => {
    fileInput.trigger('click');
  });

  fileInput.change(() => {
    // Set image preview on file input change
    const profile_picture = fileInput[0].files[0];

    imagePreview.attr('src', URL.createObjectURL(profile_picture));
    // Remove hidden class to image clear
    imageClear.removeClass('hidden');
  });

  // Clear image
  const clearImage = () => {
    // Clear file input value
    fileInput.val('');
    // Change image preview src
    imagePreview.attr('src', default_pfp_2d);
    // Add hidden class to image clear
    imageClear.addClass('hidden');
  };

  // Clear image on click
  imageClear.click(clearImage);
});
